<div id="managePartySignUpPage" #managePartySignUpPage style="background-color: HSL(225, 40%, 98%);">
    <app-header title="Party Signup"></app-header>
    <app-party-signup-list></app-party-signup-list>
</div>